module.exports = __webpack_public_path__ + "static/media/AnswerIncorrect.8a4f0086.mp3";